// views/master/ivr/index.jsx

import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Badge,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import { IoSearchOutline } from 'react-icons/io5';
import {
  getIncomingCall,
  searchIncomingCall,
} from '../../../redux/actions/Master.action';

export default function IncomingCall() {
  const [mainPage, setMainPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchDefault, setSearchDefault] = useState({
    page: '',
    search: '',
    startDate: '',
    endDate: '',
  });

  const limits = {
    page: mainPage,
    limit: rowsPerPage,
  };

  const dispatch = useDispatch();
  const getProblems = useSelector((state) => state.master);

  const handleSearch = (e) => {
    const newSearchQuery = e.target.value;
    setSearchQuery(newSearchQuery);
    const newSearchParams = {
      ...searchDefault,
      search: newSearchQuery || '',
      page: mainPage,
      startDate,
      endDate,
    };
    setSearchDefault(newSearchParams);
    const queryParams = new URLSearchParams(newSearchParams).toString();
    dispatch(searchIncomingCall(queryParams));
  };

  const handleStartDate = (e) => {
    const val = e.target.value;
    setStartDate(val);
    const newSearchParams = {
      ...searchDefault,
      search: searchQuery,
      page: 1,
      startDate: val,
      endDate,
    };
    setMainPage(1);
    setSearchDefault(newSearchParams);
    const queryParams = new URLSearchParams(newSearchParams).toString();
    dispatch(searchIncomingCall(queryParams));
  };

  const handleEndDate = (e) => {
    const val = e.target.value;
    setEndDate(val);
    const newSearchParams = {
      ...searchDefault,
      search: searchQuery,
      page: 1,
      startDate,
      endDate: val,
    };
    setMainPage(1);
    setSearchDefault(newSearchParams);
    const queryParams = new URLSearchParams(newSearchParams).toString();
    dispatch(searchIncomingCall(queryParams));
  };

  const ChangeMainPage = (selected) => {
    const newPage = parseInt(selected.selected) + 1;
    setMainPage(newPage);
    const updatedSearchParams = {
      ...searchDefault,
      search: searchQuery,
      page: newPage,
      startDate,
      endDate,
    };
    setSearchDefault(updatedSearchParams);
    const queryParams = new URLSearchParams(updatedSearchParams).toString();
    dispatch(searchIncomingCall(queryParams));
  };

  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setMainPage(1);
  };

  const postPerPage = rowsPerPage;
  const PageCount = Math.ceil(
    getProblems?.getIncomingCall?.data?.totalCount / postPerPage,
  );

  useEffect(() => {
    if (searchQuery || startDate || endDate) {
      const updatedSearchParams = {
        ...searchDefault,
        search: searchQuery,
        page: mainPage,
        startDate,
        endDate,
      };
      const queryParams = new URLSearchParams(updatedSearchParams).toString();
      dispatch(searchIncomingCall(queryParams));
    } else {
      dispatch(getIncomingCall(limits));
    }
  }, [mainPage, rowsPerPage]);

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const formatTime = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12 || 12;
    return `${String(hours).padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;
  };

  return (
    <>
      {/* Header + Filters */}
      <div className="mt-[100px]">
        <div className="d-flex flex-wrap items-end gap-3 mb-4">
          {/* Start Date */}
          <div>
            <label className="form-label fw-semibold mb-1 d-block">
              Start Date
            </label>
            <input
              type="date"
              value={startDate}
              onChange={handleStartDate}
              className="form-control shadow-none focus:!border-theme-dark"
              style={{ minWidth: '160px' }}
            />
          </div>

          {/* End Date */}
          <div>
            <label className="form-label fw-semibold mb-1 d-block">
              End Date
            </label>
            <input
              type="date"
              value={endDate}
              onChange={handleEndDate}
              className="form-control shadow-none focus:!border-theme-dark"
              style={{ minWidth: '160px' }}
            />
          </div>

          {/* Search */}
          <div className="ms-auto">
            <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2">
              <IoSearchOutline />
              <input
                type="text"
                name="search"
                value={searchQuery}
                onChange={handleSearch}
                className="w-full outline-none"
                placeholder="Search here..."
              />
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="mt-[20px] mb-4">
        <div className="mb-3 flex items-center justify-between mt-3">
          <h3 className="fw-bold">Incoming Call</h3>
          <div className="ms-auto border-r pe-3 me-3">
            Total Records:{' '}
            <span className="text-success border-b border-success">
              {getProblems?.getIncomingCall?.data?.totalCount || 0}
            </span>
          </div>
          <div>
            Rows per page:
            <select
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              className="ms-2 border rounded-md focus:outline-none"
            >
              <option value={10}>10</option>
              <option value={30}>30</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
            </select>
          </div>
        </div>

        <TableContainer>
          <Table variant="striped" colorScheme="blackAlpha">
            <Thead>
              <Tr>
                <Th>No</Th>
                <Th>Date</Th>
                <Th>Time</Th>
                <Th>Caller</Th>
                <Th>Call Receiver</Th>
                <Th>Recording URL</Th>
                <Th>Call Duration</Th>
                <Th>Lead</Th>
              </Tr>
            </Thead>
            <Tbody>
              {getProblems?.getIncomingCall?.data?.incomingCalls?.length > 0 ? (
                getProblems?.getIncomingCall?.data?.incomingCalls?.map(
                  (res, index) => (
                    <Tr key={res._id || index}>
                      <Td>{(mainPage - 1) * rowsPerPage + index + 1}</Td>
                      <Td>{formatDate(res.date || res.createdAt)}</Td>
                      <Td>{formatTime(res.date || res.createdAt)}</Td>
                      <Td>{res.caller || '-'}</Td>
                      <Td>{res.callReceiver || '-'}</Td>
                      <Td>
                        {res.recordingUrl && res.recordingUrl !== 'No Voice' ? (
                          <a
                            href={res.recordingUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="text-primary text-decoration-underline"
                          >
                            View Recording
                          </a>
                        ) : (
                          '-'
                        )}
                      </Td>
                      <Td>
                        {res.callDuration ? `${res.callDuration} sec` : '-'}
                      </Td>
                      <Td>
                        {res.isLead === true || res.isLead === 'true' ? (
                          <Badge
                            colorScheme="green"
                            px={3}
                            py={1}
                            borderRadius="md"
                          >
                            Lead
                          </Badge>
                        ) : (
                          <Badge
                            colorScheme="red"
                            px={3}
                            py={1}
                            borderRadius="md"
                          >
                            New
                          </Badge>
                        )}
                      </Td>
                    </Tr>
                  ),
                )
              ) : (
                <Tr>
                  <Td colSpan={8} textAlign="center">
                    No Incoming Calls Found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </div>

      <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={ChangeMainPage}
        pageRangeDisplayed={5}
        pageCount={PageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        className="pagination"
      />
    </>
  );
}
